import BaseComponent from 'foundation/base-component';
import React from 'react';
import { render } from 'react-dom';
import { Provider as ReduxProvider } from 'react-redux';
import SSOForm from './components/SSOForm';
import configureStore from './store/configure-store';
import { AmplifyClient } from '../../project/amplify-client';

export default class SSOFormComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.init();
    }

    init() {
        this.data = {};

        try {
            AmplifyClient.init();
            this.data = JSON.parse(this.getAttribute(this.refs.data, 'options'));
        } catch (error) {
            console.log(error.message);
        }

        if (!this.data) {
            console.log('No data found');
            return;
        }

        const store = configureStore();

        render(
            <ReduxProvider store={store}>
                <SSOForm
                    formData={this.data}
                ></SSOForm>
            </ReduxProvider>,
            this.refs.section
        );
    }
}
